<template>
  <div class="mobile-page container-fluid">
    <div class="row">
      <div class="col">
            <strong>Project in development</strong><br><br>
            <div class="img-container">
              <img src="@/assets/interactive/mobile/sketch_v01.jpg">
            </div>
            This application will help you visualize your problems using the iconic tarot cards. This innovative technique used recently in psychology is helping patients externalize their problems and start a discussion on them. This application is not intended to be an answer to everything but rather a supportive tool to help healing. <br><br>
            Cette application vous aidera à visualiser vos problèmes en utilisant les cartes de tarot emblématiques. Cette technique innovante utilisée récemment en psychologie aide les patients à externaliser leurs problèmes et à entamer une discussion sur ceux-ci. Cette application n'est pas destinée à être une réponse à tout, mais plutôt un outil de soutien à la guérison.
            <br><br>
            <div class="img-container">
              <div class="row small">
                <div class="col">
                  <img src="@/assets/interactive/mobile/mat.jpg">
                </div>

              </div>
              <div class="row">
                <div class="col-6 small">
                  <img src="@/assets/interactive/mobile/bateleur.jpg">
                </div>
                 <div class="col-6 small">
                  <img src="@/assets/interactive/mobile/chariot.jpg">
                </div>
              </div>
              <div class="row">
                <div class="col-6 small">
                  <img src="@/assets/interactive/mobile/hermite.jpg">
                </div>
                 <div class="col-6 small">
                  <img src="@/assets/interactive/mobile/imperatrice.jpg">
                </div>
              </div>
              <div class="row">
                <div class="col-6 small">
                  <img src="@/assets/interactive/mobile/justice.jpg">
                </div>
                 <div class="col-6 small">
                  <img src="@/assets/interactive/mobile/lune.jpg">
                </div>
              </div>

            </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobile',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title{
    text-align:center;
}
.mobile-page{
    text-align: center;
    padding:5% 20% 0 10%;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.9em;
}
.img-container{
  text-align:center;
  margin-left: 25%;
  margin-right: 25%;
  padding-bottom: 3%;
  height: auto;
}
.small{
  margin-bottom: 6%;
}
img{
  width:100%;
  height: 100%;
}
</style>
